import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2031ae15"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "container-fluid",
  style: {"padding":"0 10%"}
}
const _hoisted_3 = { class: "jumbotron" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-10" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Настройки")
], -1))
const _hoisted_6 = { class: "col-2" }
const _hoisted_7 = { class: "Settings-buttons" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Нормативный отступ в транспорте ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Нормативное смещение в транспорте ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Тип отклонения", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Вид рисования схем", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Сторона двери", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Высота перекрытия ярусов (мм) ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Максимальная разница между ТС (кг) ", -1))
const _hoisted_17 = {
  key: 0,
  class: "Changes-warning"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dx-button-text" }, "Сохранить ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_EnumControl = _resolveComponent("EnumControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_SettingsInfoDialog = _resolveComponent("SettingsInfoDialog")!

  return (_ctx.isShowSettings)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("header", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_DxButton, {
                  class: "float-end",
                  width: 36,
                  type: "normal",
                  icon: "info",
                  hint: "Справка",
                  "styling-mode": "contained",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onShowInfo($event)))
                })
              ])
            ])
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onFormSubmit($event)))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_DxCheckBox, {
                    class: "Settings-checkbox",
                    value: _ctx.model.useGroupByCargo,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.useGroupByCargo) = $event)),
                    onValueChanged: _ctx.haveChanges,
                    text: "Единая таблица для грузов (в плане)"
                  }, null, 8, ["value", "onValueChanged"]),
                  _createVNode(_component_DxCheckBox, {
                    class: "Settings-checkbox",
                    value: _ctx.model.useCargoGrPrecision,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.useCargoGrPrecision) = $event)),
                    text: "Учет веса грузов с точностью до грамм",
                    onValueChanged: _ctx.haveChanges
                  }, null, 8, ["value", "onValueChanged"]),
                  _createVNode(_component_DxCheckBox, {
                    class: "Settings-checkbox",
                    value: _ctx.model.showSchemeFromVehicleBackInPlan,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.showSchemeFromVehicleBackInPlan) = $event)),
                    text: "Показать на схеме вид сзади (в плане)",
                    onValueChanged: _ctx.haveChanges
                  }, null, 8, ["value", "onValueChanged"]),
                  _createVNode(_component_DxCheckBox, {
                    class: "Settings-checkbox",
                    value: _ctx.model.showSchemeFromVehicleBackInReport,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.showSchemeFromVehicleBackInReport) = $event)),
                    text: "Показать на схеме вид сзади (в отчете)",
                    onValueChanged: _ctx.haveChanges
                  }, null, 8, ["value", "onValueChanged"]),
                  _createVNode(_component_DxCheckBox, {
                    class: "Settings-checkbox",
                    value: _ctx.model.showSchemeCutsInPlan,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.showSchemeCutsInPlan) = $event)),
                    text: "Показать на схеме разрезы (в плане)",
                    onValueChanged: _ctx.haveChanges
                  }, null, 8, ["value", "onValueChanged"]),
                  _createVNode(_component_DxCheckBox, {
                    class: "Settings-checkbox",
                    value: _ctx.model.showSchemeCutsInReport,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.showSchemeCutsInReport) = $event)),
                    text: "Показать на схеме разрезы (в отчете)",
                    onValueChanged: _ctx.haveChanges
                  }, null, 8, ["value", "onValueChanged"]),
                  _createVNode(_component_DxCheckBox, {
                    class: "Settings-checkbox",
                    value: _ctx.model.showSchemeLevelsInPlan,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.showSchemeLevelsInPlan) = $event)),
                    text: "Показать на схеме ярусы (в плане)",
                    onValueChanged: _ctx.haveChanges
                  }, null, 8, ["value", "onValueChanged"]),
                  _createVNode(_component_DxCheckBox, {
                    class: "Settings-checkbox",
                    value: _ctx.model.showSchemeLevelsInReport,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.showSchemeLevelsInReport) = $event)),
                    text: "Показать на схеме ярусы (в отчете)",
                    onValueChanged: _ctx.haveChanges
                  }, null, 8, ["value", "onValueChanged"]),
                  _createVNode(_component_DxCheckBox, {
                    class: "Settings-checkbox",
                    value: _ctx.model.drawCenterMassInReport,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.drawCenterMassInReport) = $event)),
                    text: "Рисовать центр тяжести в отчетах",
                    onValueChanged: _ctx.haveChanges
                  }, null, 8, ["value", "onValueChanged"]),
                  _createVNode(_component_DxCheckBox, {
                    class: "Settings-checkbox",
                    value: _ctx.model.separationWeight,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.separationWeight) = $event)),
                    text: "Разделение веса на \"нетто\" и \"брутто\"",
                    onValueChanged: _ctx.haveChanges
                  }, null, 8, ["value", "onValueChanged"]),
                  _createVNode(_component_DxCheckBox, {
                    class: "Settings-checkbox",
                    value: _ctx.model.showRateDiameters,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.model.showRateDiameters) = $event)),
                    text: "Рисовать частоты диаметров",
                    onValueChanged: _ctx.haveChanges
                  }, null, 8, ["value", "onValueChanged"]),
                  _hoisted_10,
                  _createVNode(_component_CatalogueSelectControl, {
                    class: "ModelField-selectControl",
                    stylingMode: "outlined",
                    id: _ctx.model.gapId,
                    "onUpdate:id": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.gapId) = $event)),
                    desc: _ctx.model.gapDescription,
                    "onUpdate:desc": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.model.gapDescription) = $event)),
                    displayDescField: "name",
                    keyField: "id",
                    catalogueComponentName: "catalogues/GapCatalogue/GapCatalogue",
                    hasEmptyValue: true,
                    onChanged: _ctx.haveChanges
                  }, null, 8, ["id", "desc", "onChanged"]),
                  _hoisted_11,
                  _createVNode(_component_CatalogueSelectControl, {
                    class: "ModelField-selectControl",
                    stylingMode: "outlined",
                    id: _ctx.model.displacementId,
                    "onUpdate:id": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.model.displacementId) = $event)),
                    desc: _ctx.model.displacementDescription,
                    "onUpdate:desc": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.model.displacementDescription) = $event)),
                    displayDescField: "name",
                    keyField: "id",
                    catalogueComponentName: "catalogues/DisplacementCatalogue/DisplacementCatalogue",
                    hasEmptyValue: false,
                    onChanged: _ctx.haveChanges
                  }, null, 8, ["id", "desc", "onChanged"]),
                  _createElementVNode("div", null, [
                    _hoisted_12,
                    _createVNode(_component_EnumControl, {
                      class: "ModelField-control",
                      id: _ctx.model.marginUnitType,
                      "onUpdate:id": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.model.marginUnitType) = $event)),
                      desc: _ctx.model.marginUnitTypeDescription,
                      "onUpdate:desc": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.model.marginUnitTypeDescription) = $event)),
                      onChanged: _ctx.haveChanges,
                      enumType: "marginUnitType",
                      stylingMode: "outlined"
                    }, null, 8, ["id", "desc", "onChanged"])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_13,
                    _createVNode(_component_EnumControl, {
                      class: "ModelField-control",
                      id: _ctx.model.drawingSchemeDescriptionType,
                      "onUpdate:id": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.model.drawingSchemeDescriptionType) = $event)),
                      desc: _ctx.model.drawingSchemeDescriptionTypeDescription,
                      "onUpdate:desc": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.model.drawingSchemeDescriptionTypeDescription) = $event)),
                      onChanged: _ctx.haveChanges,
                      enumType: "drawingSchemeDescriptionType",
                      stylingMode: "outlined"
                    }, null, 8, ["id", "desc", "onChanged"])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_14,
                    _createVNode(_component_EnumControl, {
                      class: "ModelField-control",
                      id: _ctx.model.doorSide,
                      "onUpdate:id": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.model.doorSide) = $event)),
                      desc: _ctx.model.doorSideDescription,
                      "onUpdate:desc": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.model.doorSideDescription) = $event)),
                      onChanged: _ctx.haveChanges,
                      enumType: "doorSide",
                      stylingMode: "outlined"
                    }, null, 8, ["id", "desc", "onChanged"])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_15,
                    _createVNode(_component_IntegerControl, {
                      class: "ModelField-control",
                      stylingMode: "outlined",
                      placeholder: "Высота перекрытия ярусов...",
                      min: 0,
                      value: _ctx.model.overlapTiersHeight,
                      "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.model.overlapTiersHeight) = $event)),
                      hasEmptyValue: true,
                      onChanged: _ctx.haveChanges
                    }, null, 8, ["value", "onChanged"])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_16,
                    _createVNode(_component_IntegerControl, {
                      class: "ModelField-control",
                      stylingMode: "outlined",
                      placeholder: "Максимальная разница между ТС...",
                      min: 0,
                      value: _ctx.model.maxDifferenceBetweenVehicles,
                      "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.model.maxDifferenceBetweenVehicles) = $event)),
                      hasEmptyValue: false,
                      onChanged: _ctx.haveChanges
                    }, null, 8, ["value", "onChanged"])
                  ])
                ])
              ]),
              (_ctx.changes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Изменения вступят в силу после сохранения "))
                : _createCommentVNode("", true),
              _createVNode(_component_DxButton, {
                "styling-mode": "outlined",
                class: "Settings-save",
                type: "default",
                "use-submit-behavior": true,
                "validation-group": _ctx.validationGroup
              }, {
                content: _withCtx(() => [
                  _createElementVNode("span", null, [
                    (_ctx.saving)
                      ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                          key: 0,
                          icon: "circle-notch",
                          spin: ""
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_18
                  ])
                ]),
                _: 1
              }, 8, ["validation-group"]),
              _createVNode(_component_DxButton, {
                "styling-mode": "outlined",
                class: "Settings-reset",
                type: "default",
                text: "Отмена",
                onClick: _ctx.reset,
                disabled: !_ctx.changes
              }, null, 8, ["onClick", "disabled"])
            ])
          ], 32),
          _createVNode(_component_SettingsInfoDialog, { ref: "infoDialog" }, null, 512)
        ])
      ]))
    : _createCommentVNode("", true)
}